import { readContract } from '@wagmi/core';

// eslint-disable-next-line deprecate/import
import { wagmiConfig } from '@shared/common/providers/LegacyWeb3Provider/wagmi';
import { formatNumberLocalized } from '@shared/helpers/formatters';
import { weiToNumber } from '@shared/helpers/web3/formatters';
import type { Web3Handle } from '@shared/helpers/web3/handle';

import { FARM_CONTRACT_BY_VERSION, FarmContractVersion } from '../../config/contract';

export type MagicFarmPoolsAPR = {
  farmPoolHandle: Web3Handle;
  apr: string;
};

export const fetchFarmPoolsAPR = async (
  farmPoolHandle?: Web3Handle,
): Promise<MagicFarmPoolsAPR | null> => {
  if (!farmPoolHandle) {
    return null;
  }

  try {
    const result = await readContract(wagmiConfig, {
      abi: FARM_CONTRACT_BY_VERSION[FarmContractVersion.V1],
      chainId: farmPoolHandle.chainId,
      address: farmPoolHandle.address,
      functionName: 'returnCard',
    });

    return {
      farmPoolHandle,
      apr: formatNumberLocalized(weiToNumber(result[2], 18), {
        options: { minimumFractionDigits: 2 },
      }),
    };
  } catch (error) {
    console.error(error);
    return null;
  }
};
